import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Quiz = _resolveComponent("Quiz")!
  const _component_n_global_style = _resolveComponent("n-global-style")!
  const _component_n_config_provider = _resolveComponent("n-config-provider")!

  return (_openBlock(), _createBlock(_component_n_config_provider, {
    "theme-overrides": _ctx.themeOverrides,
    abstract: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Quiz),
      _createVNode(_component_n_global_style)
    ]),
    _: 1
  }, 8, ["theme-overrides"]))
}